// extracted by mini-css-extract-plugin
module.exports = {"letter_spacing_1":"_3kJwWHTk","line_clamp_5":"_1IGqPtrc","no_line_clamp":"fBLkRkmB","chevron":"IaMudFU5","bottom":"_1UpoV14_","round_up_info_icon":"_1_o1q-hg"};